export const dateMillis = {
  sec_1: 1000,
  min_1: 60 * 1000,
  hour_1: 60 * 60 * 1000,
  day_1: 24 * 60 * 60 * 1000,
  week_1: 7 * 24 * 60 * 60 * 1000,
  month_1: 30 * 24 * 60 * 60 * 1000,
  year_1: 365 * 24 * 60 * 60 * 1000,
};

export const values = {
  zeroBytes12: '0x000000000000000000000000',
  zeroBytes32: '0x0000000000000000000000000000000000000000000000000000000000000000',
  countShortNotations: ['', 'K', 'M', 'B', 'T'],
  domains: {
    prod: 'mercle.xyz',
    staging: 'timesnap.xyz',
    getBaseDomain: () => {
      return document.location.hostname.endsWith(values.domains.prod) ? values.domains.prod : values.domains.staging;
    },
    getBackendSubdomain: () => {
      return document.location.hostname.endsWith(values.domains.prod) ? 'api' : 'api';
    },
  },
};

export const resources = {
  img: {
    getAvatar: address => `https://effigy.im/a/${address}`,

    eventTags: {
      nft: '/eventTags/lootbox.svg',
      xp: `/eventTags/xp.svg`,
    },

    ipfs: ipfsUrl => {
      if (!ipfsUrl) return undefined;
      const cid = ipfsUrl?.indexOf('//') > -1 ? ipfsUrl.split('//')[1] : ipfsUrl;
      return `https://resolve.mercle.xyz/ipfs/${cid}`;
    },
    twitter: 'https://dskhnex0aho1n.cloudfront.net/public/x.svg',
    twitter_no_circle: 'https://dskhnex0aho1n.cloudfront.net/public/twitter.svg',
    telegram: 'https://app.mercle.xyz/icon/telegram.svg',
    facebook: 'https://app.mercle.xyz/icon/facebook.svg',
    copywhite: 'https://app.mercle.xyz/icon/copyWhite.svg',
  },
  links: {
    referralLink: referralCode => `${document.location.host}/r/${referralCode}`,
    s3: {
      prod: 'storage-mercle-prod',
      staging: 'storage-daohook-staging',
      getS3Bucket: () => {
        return document.location.hostname.endsWith(values.domains.prod) ? resources.links.s3.prod : resources.links.s3.staging;
      },
      getS3Link: () => `https://${resources.links.s3.getS3Bucket()}.s3.amazonaws.com`,
    },
    oauth: {
      redirectBackend: () => `${apis.backend._baseUrl}/login`,
    },
    twitter: {
      userPage: handle => `https://twitter.com/intent/follow?screen_name=${handle}`,
      like: tweet_id => `https://twitter.com/intent/like?tweet_id=${tweet_id}`,
      retweet: tweet_id => `https://twitter.com/intent/retweet?tweet_id=${tweet_id}`,
      tweet: text => `https://twitter.com/intent/tweet?text=${text}`,
    },
    telegram: {
      userPage: pageId => `https://web.telegram.org/z/#${pageId}`,
      mercleGroup: 'https://t.me/mercleofficial',
    },
    uniswap: {
      swap: (tokenAddress, quantity) => `https://app.uniswap.org/#/swap?exactField=output&exactAmount=${quantity}&outputCurrency=${tokenAddress}`,
      liquidityAdd: (tokenAddress1, tokenAddress2) => `https://app.uniswap.org/#/add/v2/${tokenAddress1}/${tokenAddress2}`,
    },
    snapshot: {
      space: spaceId => `https://snapshot.org/#/${spaceId}`,
    },
    opensea: (chainId, contractAddr, tokenId) => {
      let prefix = {
        1: `https://opensea.io/assets/ethereum`,
        10: `https://opensea.io/assets/optimism`,
        137: `https://opensea.io/assets/matic`,
        169: `https://element.market/assets/manta-pacific`,
        8453: 'https://opensea.io/assets/base',
        42161: `https://opensea.io/assets/arbitrum`,
        59144: `https://linea.nftscan.com`,
        534352: `https://element.market/assets/scroll`,
        5: `https://testnets.opensea.io/assets/goerli`,
      };
      if (prefix?.[chainId]) return `${prefix?.[chainId]}/${contractAddr}/${tokenId}`;
      return undefined;
    },
  },
};

export const chainIdToNativeTokenSymbol = {
  1: 'ETH',
  5: 'GETH',
  10: 'ETH',
  56: 'BNB',
  100: 'xDai',
  137: 'MATIC',
  169: 'ETH',
  5000: 'MNT',
  8453: 'ETH',
  42161: 'ETH',
  43114: 'AVAX',
  534352: 'ETH',
};

export const rpc = {
  1: 'https://eth.llamarpc.com',
  5: 'https://eth-goerli.g.alchemy.com/v2/2P-Dl55AC-wRfFXnKxUN9HKZqur8-cnW',
  10: 'https://wider-light-sea.optimism.quiknode.pro/f3f07ca6955a0c1242a31dee2d0db257c0faccef',
  56: 'https://rpc.ankr.com/bsc',
  100: 'https://rpc.gnosischain.com',
  137: 'https://polygon-rpc.com',
  169: 'https://pacific-rpc.manta.network/http',
  5000: 'https://rpc.mantle.xyz',
  8453: 'https://base-mainnet.g.alchemy.com/v2/2P-Dl55AC-wRfFXnKxUN9HKZqur8-cnW',
  42161: 'https://distinguished-light-bird.arbitrum-mainnet.quiknode.pro/c8906c405c70519e87322d075d14044cb358b6fe',
  421614: 'https://sepolia-rollup.arbitrum.io/rpc',
  43114: 'https://api.avax.network/ext/bc/C/rpc',
  59144: 'https://linea-mainnet.infura.io/v3/fdce7fbe1a7f493ea064f7a1a21bac40',
  534352: 'https://rpc.scroll.io',
  810180: 'https://rpc.zklink.io',
  81457: 'https://rpc.blast.io',
};

export const alchemy = { apiKey: '2P-Dl55AC-wRfFXnKxUN9HKZqur8-cnW' };

export const apis = {
  gelato: {
    baseapi: {
      api: 'https://api.gelato.digital',
    },
    getTxn: taskId => `${apis.gelato.baseapi.api}/tasks/status/${taskId}`,
  },
  alchemy: {
    baseapi: {
      1: 'https://eth-mainnet.g.alchemy.com/nft/v2/vma47TKOLkZ-xH_XQh1tQFfLADEJiHQt',
      5: 'https://eth-goerli.g.alchemy.com/nft/v2/vma47TKOLkZ-xH_XQh1tQFfLADEJiHQt',
      137: 'https://polygon-mainnet.g.alchemy.com/nft/v2/vma47TKOLkZ-xH_XQh1tQFfLADEJiHQt',
      8453: 'https://base-mainnet.g.alchemy.com/nft/v2/vma47TKOLkZ-xH_XQh1tQFfLADEJiHQt',
    },
    baseapiAdminAnalytics: {
      1: `https://eth-mainnet.g.alchemy.com/v2/${alchemy.apiKey}`,
      5: `https://eth-goerli.g.alchemy.com/v2/${alchemy.apiKey}`,
      137: `https://polygon-mainnet.g.alchemy.com/v2/${alchemy.apiKey}`,
      8453: `https://base-mainnet.g.alchemy.com/v2/${alchemy.apiKey}`,
    },
  },
  backend: {
    login: () => `${apis.backend._baseUrl}/user/login`,
    logout: () => `${apis.backend._baseUrl}/user/logout`,
    refreshAccessToken: () => `${apis.backend._baseUrl}/user/refresh`,
    getLoginState: () => `${apis.backend._baseUrl}/login/loginState`,
    loginGetCookies: () => `${apis.backend._baseUrl}/login/cookies`,
    disconnectAccount: () => `${apis.backend._baseUrl}/user/disconnectAccount`,
    //oauth

    twitterLogin: postLoginRedirectUrl => `${apis.backend._baseUrl}/oauth/twitterLogin?postLoginRedirectUrl=${postLoginRedirectUrl}`,
    twitterLoginCallback: () => `${apis.backend._baseUrl}/oauth/twitterCallback`,

    // user
    getUserIdentityClaims: () => `${apis.backend._baseUrl}/user/identity/metadata`,
    getUserStats: () => `${apis.backend._baseUrl}/user/reward-stats`,
    getUserActivity: () => `${apis.backend._baseUrl}/user/claim-activity-graph`,
    updateUserMetadata: () => `${apis.backend._baseUrl}/user/updateUserMetadata`,
    getMercleDiscordInvite: () => `${apis.backend._baseUrl}/misc/mercleDiscordInvite`,

    //mrep
    getProtocolWiseMrepData: () => `${apis.backend._baseUrl}/userRankings/protocolWiseRanking`,
    getChainWiseMrepData: () => `${apis.backend._baseUrl}/userRankings/chainWiseRanking`,
    getActionStats: () => `${apis.backend._baseUrl}/userRankings/actionStats`,
    // getMrepSwapStats: address => `${apis.backend._baseUrl}/openrep/getSwapStats?userAddress=${address}`,
    // getMrepBridgeStats: address => `${apis.backend._baseUrl}/openrep/getBridgeStats?userAddress=${address}`,
    getAllProtocols: () => `${apis.backend._baseUrl}/metadata/getAllProtocolsWithMetadata`,
    getAllChains: () => `${apis.backend._baseUrl}/metadata/getAllChainMetadata`,
    getProtocolData: protocol => `${apis.backend._baseUrl}/metadata/getProtocolMetadata?protocol=${protocol}`,
    getChainData: chainId => `${apis.backend._baseUrl}/metadata/getChainMetadata?chainId=${chainId}`,
    compareRanking: () => `${apis.backend._baseUrl}/userRankings/compareRankingProtocol`,
    chainComapareRanking: () => `${apis.backend._baseUrl}/userRankings/compareRankingChain`,
    getChainMetadata: chainId => `${apis.backend._baseUrl}/metadata/getChainMetadata?chainId=${chainId}`,
    getProtocolPositioning: () => `${apis.backend._baseUrl}/userRankings/getProtocolPositionings`,
    spectateUser: address => `${apis.backend._baseUrl}/user/userProfileSpectator?address=${address}`,

    //humaned
    getWhitlistStats: () => `${apis.backend._baseUrl}/humaned/getWhitelistData`,
    getVideoToken: () => `${apis.backend._baseUrl}/humaned/getVerificationVideoTokem`,
    postVerificationVideo: () => `${apis.backend._baseUrl}/humaned/postVerficationVideo`,

    //reviews
    handleReview: () => `${apis.backend._baseUrl}/reviews`,
    getMainFeed: body => {
      let params = [];
      if (body?.eligibleOnly) params.push(`eligibleOnly=${body?.eligibleOnly}`);
      if (body?.limit) params.push(`limit=${body?.limit}`);
      if (body?.protocol) params.push(`protocol=${body?.protocol}`);
      if (body?.type) params.push(`type=${body?.type}`);
      if (body?.page) params.push(`page=${body.page}`);
      if (body?.superTake) params.push(`superTake=${body.superTake}`);
      return `${apis.backend._baseUrl}/reviews/getMainFeed?${params.join('&')}`;
    },
    getMainFeedV2: () => `${apis.backend._baseUrl}/reviews/feedV2`,
    postReaction: () => `${apis.backend._baseUrl}/reviews/reaction`,
    postSeen: () => `${apis.backend._baseUrl}/reviews/reviewsVisited`,
    reviewLeaderboard: () => `${apis.backend._baseUrl}/reviews/rankingLeaderboard`,
    superTakeEligibileProtocols: () => `${apis.backend._baseUrl}/reviews/superTakeEligibleProtocols`,
    protocolRating: project => `${apis.backend._baseUrl}/reviews/protocolRatings?protocol=${project}`,
    useMegaCode: () => `${apis.backend._baseUrl}/reviews/usedInviteCodes`,
    postMegaCode: () => `${apis.backend._baseUrl}/reviews/useCode`,
    reviewedProtocol: () => `${apis.backend._baseUrl}/reviews/reviewedProtocols`,
    getUserPosts: body => {
      let params = [];
      if (body?.address) params.push(`address=${body?.address}`);
      if (body?.limit) params.push(`limit=${body?.limit}`);
      if (body?.page) params.push(`page=${body.page}`);
      return `${apis.backend._baseUrl}/reviews/getUserPosts?${params.join('&')}`;
    },
    classifiedProtocolRating: () => `${apis.backend._baseUrl}/reviews/classifiedProtocolRatings`,
    userProtocolStatsWithRating: () => `${apis.backend._baseUrl}/reviews/userProtocolStatsWithRating`,
    postComment: () => `${apis.backend._baseUrl}/reviews/reviewComment`,
    protocolsAdmin: () => `${apis.backend._baseUrl}/reviews/protocolsForAdmin`,
    deleteComment: commentId => `${apis.backend._baseUrl}/reviews/comment?commentId=${commentId}`,
    puzzleCodeStats: () => `${apis.backend._baseUrl}/reviews/puzzleCodeStats`,
    postPuzzleCode: () => `${apis.backend._baseUrl}/reviews/usePuzzleCode`,
    userCodes: () => `${apis.backend._baseUrl}/reviews/userCodes`,
    spinsUsed: () => `${apis.backend._baseUrl}/reviews/spinsUsed`,
    createInviteCodes: () => `${apis.backend._baseUrl}/reviews/inviteCodes`,

    randomTwitterCodeUser: () => `${apis.backend._baseUrl}/reviews/randomuUserWithUnusedInviteCode`,
    getAirdropAndRankingData: protocol => `${apis.backend._baseUrl}/reviews/airdropAndRankingForProtocol?protocol=${protocol}`,
    getAllReviewsTag: () => `${apis.backend._baseUrl}/reviews/allReviewTags`,
    getReviewTagsWithReviews: protocol => `${apis.backend._baseUrl}/reviews/reviewTagsWithReviews/?protocol=${protocol}`,
    getReactionEligible: () => `${apis.backend._baseUrl}/reviews/getElgibleProtocols`,
    getTopTakers: () => `${apis.backend._baseUrl}/reviews/topTakers`,

    getAnalyticsData: () => `${apis.backend._baseUrl}/misc/analytics`,

    // _baseUrl: `https://${values.domains.getBackendSubdomain()}.${values.domains.getBaseDomain()}`,
    // _baseUrl: `http://localhost:8080`,
    _baseUrl: 'https://backend.mercle.ai',
  },
};

export const types = {
  loginVia: {
    discord: 'discord',
    email: 'email',
    twitter: 'twitter',
    telegram: 'telegram',
  },
  postLoginActions: {
    none: undefined,
    joinDiscord: 'joinDiscord',
    followTwitter: 'followTwitter',
    joinTelegram: 'joinTelegram',
    subNewsletter: 'subNewsletter',
    loginInstagram: 'loginInstagram',
    admins: {
      addDiscordBot: 'admins_addDiscordBot',
      createCommunity: 'admins_createCommunity',
    },
  },
};

export const id = {
  storage: {
    loginVia: 'loginVia',
    userStats: 'user_stats',
    nftProfiles: 'nft-profiles',
    community: communityName => `community:${communityName}`,
    communityRaffle: communityName => `community_raffles:${communityName}`,

    allEvents: 'allEvents',
    event: communityName => `v2_event_${communityName}`,

    campaign: campaignName => `campaign_${campaignName}`,
    tokenSymbol: (address, chainId) => `tokenSymbol:${chainId}:${address}`,
    tokenDecimals: (address, chainId) => `tokenDecimals:${chainId}:${address}`,

    nftProfile: (ownerAddress, tokenAddress, chainId) => `nft_profile_${ownerAddress}_${tokenAddress}_${chainId}`,

    referralCode: `referralCode`,
    mintFeeTxnHash: commId => `mintTxnHash_${commId}`,
    attendanceCode: 'attendanceCode',
    ensDetails: address => `ens_details_${address}`,
  },
};

export const chainexplorer = {
  1: (a, isTxn = false) => `https://etherscan.io/${!isTxn ? 'address' : 'tx'}/${a}`,
  3: (a, isTxn = false) => `https://ropsten.etherscan.io/${!isTxn ? 'address' : 'tx'}/${a}`,
  5: (a, isTxn = false) => `https://goerli.etherscan.io/${!isTxn ? 'address' : 'tx'}/${a}`,
  10: (a, isTxn = false) => `https://optimistic.etherscan.io/${!isTxn ? 'address' : 'tx'}/${a}`,
  42: (a, isTxn = false) => `https://kovan.etherscan.io/${!isTxn ? 'address' : 'tx'}/${a}`,
  56: (a, isTxn = false) => `https://bscscan.com/${!isTxn ? 'address' : 'tx'}/${a}`,
  100: (a, isTxn = false) => `https://blockscout.com/xdai/mainnet/${!isTxn ? 'address' : 'tx'}/${a}`,
  137: (a, isTxn = false) => `https://polygonscan.com/${!isTxn ? 'address' : 'tx'}/${a}`,
  169: (a, isTxn = false) => `https://pacific-explorer.manta.network/${!isTxn ? 'address' : 'tx'}/${a}`,
  250: (a, isTxn = false) => `https://ftmscan.com/${!isTxn ? 'address' : 'tx'}/${a}`,
  1101: (a, isTxn = false) => `https://zkevm.polygonscan.com/${!isTxn ? 'address' : 'tx'}/${a}`,
  5000: (a, isTxn = false) => `https://explorer.mantle.xyz/${!isTxn ? 'address' : 'tx'}/${a}`,
  8453: (a, isTxn = false) => `https://basescan.org/${!isTxn ? 'address' : 'tx'}/${a}`,
  42161: (a, isTxn = false) => `https://arbiscan.io/${!isTxn ? 'address' : 'tx'}/${a}`,
  42220: (a, isTxn = false) => `https://explorer.celo.org/mainnet/${!isTxn ? 'address' : 'tx'}/${a}`,
  43114: (a, isTxn = false) => `https://avascan.info/blockchain/xana/${!isTxn ? 'address' : 'tx'}/${a}`,
  59144: (a, isTxn = false) => `https://explorer.linea.build/${!isTxn ? 'address' : 'tx'}/${a}`,
  534352: (a, isTxn = false) => `https://scrollscan.com/${!isTxn ? 'address' : 'tx'}/${a}`,
};

export const CHAINS = {
  1: {
    id: 1,
    name: 'Ethereum',
    type: 'L1',
    logo: 'https://dskhnex0aho1n.cloudfront.net/public/chain-logos/eth-logo.png',
    url: 'https://ethereum.org/',
    twitterUrl: 'https://x.com/ethereum',
  },
  8453: {
    id: 8453,
    name: 'Base',
    type: 'EVM-L2',
    logo: 'https://dskhnex0aho1n.cloudfront.net/public/chain-logos/base-logo.png',
    url: 'https://www.base.org/',
    twitterUrl: 'https://x.com/base',
  },
  42161: {
    id: 42161,
    name: 'Arbitrum',
    type: 'EVM-L2',
    logo: 'https://dskhnex0aho1n.cloudfront.net/public/chain-logos/arb-logo.png',
    url: 'https://arbitrum.io//',
    twitterUrl: 'https://x.com/arbitrum',
  },
  10: {
    id: 10,
    name: 'Optimism',
    type: 'EVM-L2',
    logo: 'https://dskhnex0aho1n.cloudfront.net/public/chain-logos/op-logo.png',
    url: 'https://www.optimism.io/',
    twitterUrl: 'https://x.com/Optimism',
  },
  81457: {
    id: 81457,
    name: 'Blast',
    type: 'EVM-L2',
    logo: 'https://dskhnex0aho1n.cloudfront.net/public/chain-logos/blast-logo.png',
    url: 'https://blast.io/',
    twitterUrl: 'https://x.com/blast',
  },
  59144: {
    id: 59144,
    name: 'Linea',
    type: 'EVM-L2',
    logo: 'https://dskhnex0aho1n.cloudfront.net/public/chain-logos/linea-logo.png',
    url: 'https://linea.build/',
    twitterUrl: 'https://x.com/LineaBuild',
  },
};

export default { dateMillis, rpc, types, values, resources, apis, id };
